export default __webpack_public_path__ + "static/media/drc-logo.cb12f735.svg";